module.exports = __webpack_public_path__ + "static/media/rsp-logo.90884d94.svg";